export default "__VITE_ASSET__CKhFOICG__"